import { CustomLayerPosition, ICustomLayer } from '@/framework';
import { Framework } from '@/framework/instance';

/** 自定义图层 */
export class CustomLayer extends Framework {
    /**
     * 添加自定义图层
     *
     * @param originIndex - 原始索引
     * @param type - 类型
     * @param node - 节点
     * @param position - 位置
     */
    add(originIndex: number, type: string, node: React.ReactNode, position: CustomLayerPosition) {
        return this.framework.stage.customLayer.add(originIndex, type, node, position);
    }

    /**
     * 移除自定义图层
     */
    remove(item: ICustomLayer) {
        this.framework.stage.customLayer.remove(item);
    }
}
